import CardWrapper from "./CardWrapper"
import styles from "../../styles/portfolioManagerDashboard.module.scss"

function SimpleCard({
  title = "Portfolio Performance",
  value,
  secondaryValue = null,
  infoText,
}) {

  const overAllValue = secondaryValue !== null ? `${value} of ${secondaryValue}` : value;
  const overAllValuePercentage = secondaryValue !== null ? Math.round((value / secondaryValue) * 100) : null;
  return (
    <CardWrapper classNames={styles.simpleCard} infoText={infoText}>
      <div className={styles.cardTop}>
        <span className={styles.label}>{title}</span>
        <div className={styles.cardMain} style={{ justifyContent: 'center' }}>
          <div className={styles.value}>{value}</div>
        </div>
      </div>
      <div className={styles.cardFooter} style={{ justifyContent: 'center' }}>
        {
          secondaryValue &&
          <span className={`${styles.trendBadge} ${styles.neutral}`}>
            {`${overAllValue} • ${overAllValuePercentage}%`}
          </span>
        }

      </div>
    </CardWrapper>
  )
}

export default SimpleCard
